import React from 'react';
import * as S from './ProductSearchResultTile.style';
import { Flex, Image, Caption, useStyles } from '@archipro-design/aria';
import type {
    ProductTaggingSearchResult,
    TagDataUseToCreateTag,
} from '@modules/product-tagging/type';
import { convertSearchResultToTagType } from '../../util/convert-search-result-to-tag-type';

interface ProductSearchResultTileProps {
    tileData: ProductTaggingSearchResult;
    onConfirm: (data: TagDataUseToCreateTag) => void;
    showProfessionalName?: boolean;
}

const ProductSearchResultTile = ({
    tileData,
    showProfessionalName,
    onConfirm,
}: ProductSearchResultTileProps) => {
    const logoBackground = tileData.logoBackground;
    const { css } = useStyles({ logoBackground });

    const data = convertSearchResultToTagType(tileData);

    return (
        <Flex
            gap={'space-8'}
            className={css(S.ResultTile)}
            onClick={() => onConfirm(data)}
        >
            <div className={css(S.ResultTileThumb)}>
                <Image
                    src={tileData.thumb}
                    width={40}
                    height={40}
                    layout={'fill'}
                    objectFit={'contain'}
                    alt={tileData.title ?? ''}
                />
            </div>
            <Flex column className={css(S.ResultTileContent)}>
                <Caption variant="04" className={css(S.ResultTileTitle)}>
                    {tileData.title}
                </Caption>
                {tileData.professional && showProfessionalName && (
                    <Caption
                        variant="04"
                        className={css(S.ResultTileProfessional)}
                    >
                        {tileData.professional}
                    </Caption>
                )}
            </Flex>
        </Flex>
    );
};

export default ProductSearchResultTile;
